import api from "@/api/axios";

const API_URL = "/sessions";

export const createSession = (session) => api.post(API_URL, session);
export const getSessions = () => api.get(API_URL);
export const getLiveSessions = () => api.get(`${API_URL}/live`);
export const getAsyncSessions = () => api.get(`${API_URL}/async`);
export const getSession = (id) => api.get(`${API_URL}/${id}`);
export const updateSession = (id, session) => api.put(`${API_URL}/${id}`, session);
export const deleteSession = (id) => api.delete(`${API_URL}/${id}`);
export const copySession = (id, title) => api.post(`${API_URL}/${id}/copy`, { title });

export const getCriterionAverages = (sessionId) =>
  api.get(`${API_URL}/${sessionId}/criteria/averages`);
